import React from 'react';
import { Outlet } from 'react-router-dom';

import { ContactsContextProvider } from '../contexts/ContactsContext';

const LoggedOutLayout = () => {
  return (
    <ContactsContextProvider>
      <Outlet/>
    </ContactsContextProvider>
  );
};

export default LoggedOutLayout;
